module.exports = __webpack_public_path__ + "img/arrow-up-blue-used.a3c8f315.svg";